
const digest = '9c44fa515ca327b93ba305055c128ae903cd64d8040de06e654520246d867f27';
const css = `._header_169k7_1 {
  display: flex;
  margin-bottom: -4em;
  padding: 2em;
}

@media screen and (max-width: 1000px) {
  ._header_169k7_1 {
    margin-bottom: -3em;
  }
}

._github_169k7_13 {
  position: absolute;
  right: 0;
  top: 0;
}

._ruby_169k7_19 {
  margin-right: 2em;
  width: 8vw;
  height: 8vw;
}

@media screen and (max-width: 1000px) {
  ._ruby_169k7_19 {
    width: 4em;
    height: 4em;
  }
}

@media screen and (max-width: 800px) {
  ._ruby_169k7_19 {
    width: 7em;
    height: 7em;
  }
}

._title_169k7_39 {
  color: var(--secondary-color);
  font-weight: normal;
}
`;

(function() {
  if (typeof document === 'undefined') {
    return;
  }
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"header":"_header_169k7_1","github":"_github_169k7_13","ruby":"_ruby_169k7_19","title":"_title_169k7_39"};
export { css, digest };
  